<template>
  <div>
    <layout-header title="Registro de Recomendaciones" subtitle="Informe sobre la situación económica de las ESI" />
    <ets-page>
      <download-section v-if="isAllowed" ref="downloadSection" procedure="reco-registries" />
      <forbidden v-else />
    </ets-page>
  </div>
</template>

<script>
import { mapState } from "vuex";
import LayoutHeader from "@/components/Layout/LayoutHeader";
import DownloadSection from "@/components/Download/DownloadSection";
import Forbidden from "@/components/Forbidden";

export default {
  name: "PageSolvency",
  components: {
    LayoutHeader,
    DownloadSection,
    Forbidden
  },
  computed: {
    ...mapState(["userPermissions"]),
    isAllowed() {
      return this.userPermissions && this.userPermissions.EAFI_AXE_Recos;
    }
  }
};
</script>
